import { TextareaAutosize, Typography } from "@mui/material";

import { RendererProps } from "./Input";

const TextArea = ({ label, ...props }: RendererProps) => {
  return (
    <Typography
      component="div"
      sx={{
        display: "flex",
        width: "100%",
        "& textarea": {
          padding: "16.5px 14px",
          font: "inherit",
          borderColor: "rgba(0, 0, 0, 0.23)",
          borderRadius: "4px",
          background: "none",
          width: "100%",
          "&::placeholder": {
            color: "currentColor",
            font: "inherit",
            opacity: 0.42,
          },
        },
      }}
    >
      <TextareaAutosize {...props} minRows={3} value={props.value as string} />
    </Typography>
  );
};

export default TextArea;
